import { BaseContainerModel } from '../../base-container.model';
import { bl_crm_label_hdr_RowClass } from '../../../dbschema';

export class LabelCrmContainerModel extends BaseContainerModel {
  bl_crm_label_hdr: bl_crm_label_hdr_RowClass = new bl_crm_label_hdr_RowClass();
}
